import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { setcurrentmenu } from "../../stores/menuslice";
import UsersTable from "./childcomponents/userstable";
import UserUpdateForm from "./childcomponents/userupdateform";
import { Box, Card, Button, Paper } from "@mui/material";

export default function Users() {
    const dispatch = useAppDispatch();
    const [createUser, setCreateUser] = useState<boolean>(false);

    function handleClick() {
        setCreateUser(true);
    }

    useEffect(() => {
        dispatch(setcurrentmenu('users'));

    }, []);
    return (<>

        <Box sx={{ width: '100%' }}>
            <UsersTable />
        </Box>
    </>
    );
}